import { createStore } from 'vuex'
import axios from 'axios';

export default createStore({
	state: {
		content: [],
	},
	mutations: {
		SAVE_DATA (state, data) {
			state.content = data.data.data;
			// console.log("data opgeslagen", data.data);
		}, 
	},
	getters: {
		articleItems: state => state.articles
	},
	actions: {
		loadContent ({ commit, state }) {
			return new Promise((resolve, reject) => { 
			axios
				.get(process.env.VUE_APP_API)
				.then(result => {
					// console.log("data binnengehaald", result);
					commit("SAVE_DATA", result);
					resolve();
				})
				.catch(error => {
					reject();
					throw new Error(`API ${error}`);
				});
			})
		},    
	},
	modules: {

	}
})
